import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customersAPI } from '../../api/api';

export const fetchCustomers = createAsyncThunk(
  'customers/fetchAll',
  async () => {
    const response = await customersAPI.getAll();
    return response.data.data;
  },
);

export const fetchCustomerById = createAsyncThunk(
  'customers/fetchById',
  async (id) => {
    const response = await customersAPI.getById(id);
    return response.data.data;
  },
);

export const createCustomer = createAsyncThunk(
  'customers/create',
  async (data) => {
    const response = await customersAPI.create(data);
    return response.data.data;
  },
);

export const updateCustomer = createAsyncThunk(
  'customers/update',
  async ({ id, data }) => {
    const response = await customersAPI.update(id, data);
    return response.data.data;
  },
);

export const deleteCustomer = createAsyncThunk(
  'customers/delete',
  async (id) => {
    await customersAPI.delete(id);
    return id;
  },
);

const customersSlice = createSlice({
  name: 'customers',
  initialState: {
    items: [],
    currentCustomer: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentCustomer: (state) => {
      state.currentCustomer = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCustomerById.fulfilled, (state, action) => {
        state.currentCustomer = action.payload;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.items = state.items.filter((item) => item.id !== action.payload);
      });
  },
});

export const { clearCurrentCustomer, clearError } = customersSlice.actions;
export default customersSlice.reducer;
